import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CommentCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItem: 'center',
  padding: theme.spacing(1),
  ml: theme.spacing(1),
  border: `1px solid ${theme.palette.primary.contrastText}`,
}));
